/**
 * @generated SignedSource<<44868f70b543817681e71f44f984833c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type advertisersHomeV2QueueItemConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly entityId?: string;
      readonly " $fragmentSpreads": FragmentRefs<"homeAdvertiserV2ContentItemContent">;
    };
  }>;
  readonly " $fragmentType": "advertisersHomeV2QueueItemConnection";
};
export type advertisersHomeV2QueueItemConnection$key = {
  readonly " $data"?: advertisersHomeV2QueueItemConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"advertisersHomeV2QueueItemConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "advertisersHomeV2QueueItemConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QueueItemsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entityId",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "homeAdvertiserV2ContentItemContent"
                }
              ],
              "type": "Content",
              "abstractKey": "__isContent"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemConnection",
  "abstractKey": null
};

(node as any).hash = "868ae10970c60181f3b9b14695f20437";

export default node;
